export type Theme = 'light' | 'dark';

/**
 * localStorage key for the user's explicit choice. `public/theme-init.js` reads the same
 * key before the app loads, so the two must stay in step.
 */
export const THEME_STORAGE_KEY = 'our_church_theme';

export function isTheme(value: unknown): value is Theme {
  return value === 'light' || value === 'dark';
}

/**
 * An explicit choice wins; without one, follow the operating system preference.
 */
export function resolveTheme(stored: string | null, prefersDark: boolean): Theme {
  if (isTheme(stored)) return stored;
  return prefersDark ? 'dark' : 'light';
}
